<template>
	<section class v-loading="loadings.main" style="width: 100%">
		<div class="d-flex mt-3 mb-3" v-if="hasGetTableDataModel">
			<div class="mr-auto">
				<el-checkbox
						:indeterminate="isIndeterminate"
						v-model="isCheckAll"
						@change="handleCheckAllChange"
						v-if="isSelectable"
						class="mr-3"
				>全选</el-checkbox>
				<el-button
						size="mini"
						class="mr-3"
						v-for="op in batchOps"
						:key="op.key"
						:disabled="!isCheckAll && !isIndeterminate"
						@click="handleClickBatchOp(op.key)"
				>{{op.name}}</el-button>
			</div>
			<el-popover placement="bottom" width="300" trigger="click">
				<el-checkbox-group v-model="fieldsShow">
					<el-checkbox
							:key="index"
							v-for="(key,index) in fields"
							:label="key.name"
					>{{key.show_name || dm[key.name].show_name}}</el-checkbox>
				</el-checkbox-group>
				<el-button icon="el-icon-view" circle size="mini" slot="reference"></el-button>
			</el-popover>
		</div>
		<el-table
			:data="sumDatas"
			style="width: 100%"
			border
			v-loading="loadings.main"
			@sort-change="handleSortChange"
			size="small"
			v-if="hasGetTableDataModel"
			show-summary
		>
			<el-table-column width="55" label="选择" v-if="isSelectable">
				<template slot-scope="scope">
					<el-checkbox v-model="checks[scope.$index]" @change="handleCheck(scope.$index)"></el-checkbox>
				</template>
			</el-table-column>
			<el-table-column
				:prop="key.name"
				:label="dataModels[dataModel][key.name].show_name"
				:sortable="key.sortable"
				:key="key.name"
				v-for="(key,index) in dataFields"
				:min-width="key.minWidth"
				:width="key.width"
				:fixed="key.fixed"
			>
				<template slot-scope="scope">
					<field-show-tiple
						:field-info="dataModels[dataModel][key.name]"
						:value="scope.row.data[key.name]"
						:field-key="key"
						:params="key.params"
						v-if="scope.row.data"
					></field-show-tiple>
					<span v-else>{{scope.row._id}}</span>
				</template>
			</el-table-column>
			<el-table-column
				:prop="key.name"
				:label="key.title"
				:sortable="key.sortable"
				:key="index"
				v-for="(key,index) in fields"
				:min-width="key.minWidth"
				:width="key.width"
				:fixed="key.fixed"
				:align="key.toFixed?'right':'left'"
			>
				<template slot-scope="scope">
					<span>
						<span v-if="key.prefix">{{key.prefix}}</span>
						<span
							class="text-bold"
							v-if="key.toFixed"
						>{{scope.row[key.name] | toFixed(key.toFixedLength)}}</span>
						<span class="text-bold" v-else>{{scope.row[key.name]}}</span>
						<span v-if="key.postfix">{{key.postfix}}</span>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" v-if="hasOpSlot" class-name="list-op">
				<template slot-scope="scope">
					<slot name="listOp" v-bind:row="scope.row"></slot>
				</template>
			</el-table-column>
		</el-table>
		<div class="row" v-if="hasPage">
			<div class="col-lg-12 mt-3">
				<el-pagination
					layout="prev, next"
					:total="paginations.main.total>500?500:paginations.main.total"
					:page-size="this.paginations.main.perPage"
					background
					@current-change="handlePageChange"
				></el-pagination>
			</div>
		</div>
	</section>
</template>

<script>
import LoadDM from "@/mixins/LoadDM.js";
import FieldShowTiple from './FieldShowTiple.vue';
import CurdTable from "@/mixins/CurdTable.js";

export default {
  components: { FieldShowTiple },
	mixins: [LoadDM, CurdTable],
	data() {
		return {
			loadings: {
				main: false
			},
			hasGetData: false,
			sumDatas: [],
			sorts: {
				sortKey: "sum_total_price",
				sortOrder: "desc"
			},
			paginations: {
				main: {
					pageNow: 1,
					total: 0,
					perPage: 50
				}
			}
		};
	},
	props: {
		dataModel: {
			type: String,
			default: ""
		},
		kvFilter: {
			type: Object,
			default: function() {
				return {};
			}
		},
		fields: {
			type: Array,
			default: function() {
				return [];
			}
		},
		dataFields: {
			type: Array,
			default: function() {
				return [];
			}
		},
		listUrl: {
			type: String,
			default: ""
		},

		searchFilter: {
			type: String,
			default: ""
		},
		dateFilter: {
			type: Array
		},
		warehouseFilter: {
			type: Object,
			default: function() {
				return {
					_id: ""
				};
			}
		},
		autoLoad: {
			type: Boolean,
			default: true
		},
		hasPage: {
			type: Boolean,
			default: true
		},
		hasOpSlot: {
			type: Boolean,
			default: false
		},
		sortsDefault: {
			type: Object,
			default: function() {
				return {
					sortKey: "sum_total_price",
					sortOrder: "desc"
				};
			}
		}
	},
	computed: {},
	created() {
		this.dataModelName = this.dataModel;
	},
	mounted() {
		this.refreshData();
		this.sorts.sortKey = this.sortsDefault.sortKey;
		this.sorts.sortOrder = this.sortsDefault.sortOrder;
	},
	methods: {
		handlePageChange(pageNow) {
			this.paginations.main.pageNow = pageNow;
			if (!this.autoLoad) {
				//无需加载的，只需要告诉外面变了
				//其他的本就外面处理，只需要处理 sort 和 page
				this.$emit("refresh", {
					sortKey: this.sorts.sortKey,
					sortOrder: this.sorts.sortOrder,
					page: this.hasPage ? this.paginations.main.pageNow : -999
				});
				return;
			}
			this.refreshData();
		},
		handleSortChange({ column, prop, order }) {
			if (order == "ascending") {
				order = "asc";
			} else if (order == "descending") {
				order = "desc";
			} else {
			}
			this.sorts.sortKey = prop;
			this.sorts.sortOrder = order;
			if (!this.autoLoad) {
				//无需加载的，只需要告诉外面变了
				//其他的本就外面处理，只需要处理 sort 和 page
				this.$emit("refresh", {
					sortKey: this.sorts.sortKey,
					sortOrder: this.sorts.sortOrder,
					page: this.hasPage ? this.paginations.main.pageNow : -999
				});
				return;
			}
			this.refreshData();
		},
		refreshData() {
			this.checks = []
			this.loadings.main = true;
			const url = this.listUrl ? "/" + this.listUrl : `/curd/sum_count/${this.dataModel}`;
			this.$axios
				.post(url, {
					page: this.hasPage ? this.paginations.main.pageNow : -999,
					sortKey: this.sorts.sortKey,
					sortOrder: this.sorts.sortOrder,
					searchFilter: this.searchFilter,
					dateFilter: this.dateFilter,
					kvFilter: this.kvFilter,
					warehouseFilter: this.warehouseFilter._id
				})
				.then(json => {
					this.loadings.main = false;
					this.sumDatas = [];
					let datas = {};
					for (let k in json.data.datas) {
						datas[json.data.datas[k]._id] = json.data.datas[k];
					}
					this.setData(json.data.datas);
					let counter = 0;
					for (let k in json.data.sums) {
						counter++;

						if (k == "") {
							continue;
						}
						json.data.sums[k].data = datas[json.data.sums[k]._id];
						this.sumDatas.push(json.data.sums[k]);
					}
					this.$emit('getsumdata', this.sumDatas);
					if (counter >= this.paginations.main.perPage) {
						this.paginations.main.total = this.paginations.main.perPage * (this.paginations.main.pageNow + 1);
					} else {
						this.paginations.main.total = this.paginations.main.perPage * (this.paginations.main.pageNow - 1) + counter;
					}
				})
				.catch(json => {
					this.loadings.main = false;
				});
		},
	},
	watch: {
		kvFilter: {
			handler(val) {
				if (val) {
					this.refreshData();
				}
			},
			immediate: false,
			deep: true
		},
		searchFilter: {
			handler(newVal, oldVal) {
				if (newVal != oldVal) {
					this.refreshData();
				}
			},
			immediate: false
		},
		dateFilter: {
			handler(newVal, oldVal) {
				if (newVal != oldVal) {
					this.refreshData();
				}
			},
			immediate: false
		},
		warehouseFilter: {
			handler(newVal, oldVal) {
				if (newVal != oldVal) {
					this.refreshData();
				}
			},
			immediate: false
		}
	}
};
</script>
